/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Allocate a buffer using an octet array.
*
* @module @stdlib/buffer-from-array
*
* @example
* import array2buffer from '@stdlib/buffer-from-array';
*
* var buf = array2buffer( [ 1, 2, 3, 4 ] );
* // returns <Buffer>
*/

// MODULES //

import hasFrom from './has_from.js';
import main from './main.js';
import polyfill from './polyfill.js';


// MAIN //

var array2buffer;
if ( hasFrom ) {
	array2buffer = main;
} else {
	array2buffer = polyfill;
}


// EXPORTS //

export default array2buffer;
